import React from 'react';
import { IoWarning } from "react-icons/io5";
import { FaSpinner } from 'react-icons/fa';


const Expired = ({handleConfirmPayment, buttonLoading, handleRetryGenerate}) => {

  return (
    <div>
    
      <div className="flex justify-center items-center h-20">
        <IoWarning className='text-5xl text-yellow-400'/>
      </div>
      <p className="text-[var(--Checkout-text-color)] Inter-Regular text-lg mb-8 text-center">
        Account expired
      </p>
      <div className='flex items-center justify-center mb-1 Inter-Regular'>
        <button
          className="px-2 py-[0.4rem] border w-64 border-[#d0d5dd] bg-[#f8fafc] rounded-xl outline-none sm:w-[17rem] text-[var(--SarepayPrimary-color)] text-sm font-semibold"
          onClick={handleRetryGenerate}
        >
          Try again
        </button>
      </div>

      <div className='flex items-center justify-center'>
        <button
          className="px-2 py-[0.4rem] border w-64 flex items-center justify-center border-[#d0d5dd] bg-[#f8fafc] text-[var(--SarepayPrimary-color)] rounded-xl outline-none mt-1 sm:w-[17rem] text-sm"
          onClick={handleConfirmPayment}
          disabled={buttonLoading}
          style={{
            backgroundColor: buttonLoading ? '#b7b7b7' : '',
            cursor: buttonLoading ? 'not-allowed' : 'pointer',
          }}
        >
          {!buttonLoading ? "I’ve sent the money" : <div className="flex items-center"> <FaSpinner className="animate-spin mr-2" /> <p className='Inter-Regular'>I already sent the money</p></div>}

        </button>
      </div>

    </div>)
}

export default Expired;
